import script from "./CityDistrictName.vue?vue&type=script&lang=js"
export * from "./CityDistrictName.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__